<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/eLearning'">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            @if (!id) {
              <span>{{ 'elearning.new' | translate }}</span>
            }
            @if (id) {
              <span>{{ 'elearning.edit' | translate }}</span>
            }
          </div>
          <div class="subtitle secondary-text">
            <span>{{ 'elearning.detail' | translate }}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <div>
        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          [disabled]="!title || !formGroup.valid || (!chosenBoards || (chosenBoards && !chosenBoards.length))"
          (click)="addELearning()">
          @if (!id) {
            <span>{{ 'main.add' | translate }}</span>
          }
          @if (id) {
            <span>{{ 'main.save' | translate }}</span>
          }
        </button>
        @if (id) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="deleteELearning()">
            <span>{{ 'main.delete' | translate }}</span>
          </button>
        }
      </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        @if (elearning?.elearningParticipants?.length) {
          <div class="participants-container">
            <elearning-participant [participants]="elearning.elearningParticipants"></elearning-participant>
          </div>
        }
        <div class="expand-button">
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="expandAll()">
            @if (!expandAllTabs) {
              <span>{{ 'event.expand_all' | translate }}</span>
            }
            @if (expandAllTabs) {
              <span>{{ 'minimize_all' | translate }}</span>
            }
          </button>
        </div>
        <div>
          <mat-expansion-panel [expanded]="expandAllTabs" (expandedChange)="infoTabOpen = $event"
            [ngStyle]="{'padding-bottom': infoTabOpen ? '30px' : '0px'}">
            <mat-expansion-panel-header [ngClass]="{'openHeader': infoTabOpen}">
              <mat-panel-title>{{ 'event.main_info' | translate }}</mat-panel-title>
              <mat-panel-description>
                {{ 'event.type_main_info' | translate }}
                <mat-icon [ngClass]="{'red-color': !title}">info</mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-checkbox [(ngModel)]="public" class="online-checkbox">{{'event.public' | translate}}</mat-checkbox>
            <mat-checkbox [(ngModel)]="showOnHome" class="online-checkbox">{{'event.showOnHome' | translate}}</mat-checkbox>
            <mat-form-field class="example-full-width">
              <input matInput required placeholder="Title" [(ngModel)]="title">
            </mat-form-field>

            <div>
              <quill-editor [(ngModel)]="editorContent">
              </quill-editor>
            </div>
            <div class="choose-organization">
              <form [formGroup]="formGroup" class="choose-organization-form">
                @if (formGroup.get('countryId')?.enabled) {
                <mat-form-field class="choose-organization-select">
                  <mat-label>{{'user.country' | translate}}</mat-label>
                  <mat-select formControlName="countryId" required>
                    @for (country of countries; track country.id) {
                      <mat-option [value]="country.id">
                        <span>{{ country.name }}</span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                }
                @if (formGroup.get('cityId')?.enabled) {
                  <mat-form-field class="choose-organization-select">
                    <mat-label>{{'user.city' | translate}}</mat-label>
                    <mat-select formControlName="cityId" required>
                      @for (city of cities; track city) {
                        <mat-option [value]="city.id">
                          <span>{{ city.name }}</span>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (formGroup.get('organizationId')?.enabled) {
                  <mat-form-field class="choose-organization-select">
                    <mat-label>{{'user.organization' | translate}}</mat-label>
                    <mat-select formControlName="organizationId" required>
                      @for (organization of organizations; track organization.id) {
                        <mat-option [value]="organization.id">
                          <span>{{ organization.name }}</span>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (platforms && platforms.length && platforms.length > 1 && !platformId) {
                  <mat-form-field class="platform">
                    <mat-label>{{'event.platforms' | translate}}</mat-label>
                    <mat-select  multiple (selectionChange)="changePlatforms($event)"
                                [value]="selectedPlatforms">
                      @for (plat of platforms; track plat.id) {
                        <mat-option [value]="plat.id">
                          {{plat.title}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (showLevel) {
                  <mat-form-field appearance="fill" class="level">
                    <mat-label>{{ 'event.event_level' | translate }}</mat-label>
                    <mat-select placeholder="{{ 'event.event_level_desc' | translate }}"
                                formControlName="eventLevel" multiple>
                      @for (el of eventLevels; track el.value) {
                        <mat-option [value]="el.value">
                          {{ el.label }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="fill" class="level">
                    <mat-label>{{ 'event.skill_selection' | translate }}</mat-label>
                    <mat-select placeholder="{{ 'event.skill_selection_description' | translate }}"
                                formControlName="skills" multiple>
                      @for (comp of competencies; track comp.id) {
                        <mat-optgroup [label]="comp.title">
                          @for (skill of comp.skills; track skill.id) {
                            <mat-option [value]="skill.id">
                              {{ skill.title }}
                            </mat-option>
                          }
                        </mat-optgroup>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </form>

            </div>
            <mat-card appearance="outlined" class="questions-card">
              <mat-card-header>
                <mat-card-title>
                  <div class="subtitle">{{ 'questions' | translate }}</div>
                  @if (questions.length === 0) {
                    <button mat-raised-button (click)="addQuestion()">{{ 'add_question' | translate }}</button>
                  }
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="questions">
                  @for (question of questions; track question) {
                    <div class="question">
                      <div class="question-header">
                        <mat-form-field class="question-title">
                          <input matInput required placeholder="{{'question' | translate}}" [(ngModel)]="question.title">
                        </mat-form-field>
                        <button class="remove-question" mat-raised-button
                          (click)="removeQuestion(question.id)">{{ 'remove' | translate }}
                        </button>
                      </div>
                      <mat-form-field class="question-type">
                        <mat-select placeholder="{{'frontUser.type' | translate}}"
                          [(ngModel)]="question.type">
                          <mat-option [value]="'text'">{{ 'text' | translate }}</mat-option>
                          <mat-option [value]="'single'">{{ 'singe_answer' | translate }}</mat-option>
                          <mat-option [value]="'multiple'">{{ 'multiple_answer' | translate }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                      @if (question.type === 'text') {
                        <div class="correct-answer">
                          <mat-form-field class="correct-answer-title">
                            <input matInput required placeholder="{{'correct_answer' | translate}}"
                              [(ngModel)]="question.correctAnswer">
                            </mat-form-field>
                          </div>
                        }
                        @if (question.type === 'single' || question.type === 'multiple') {
                          <div class="answers">
                            <div class="answers-title">{{ 'answers' | translate }}</div>
                            <button class="add-answer" mat-raised-button
                              (click)="addAnswer(question.id)">{{ 'add_answer' | translate }}
                            </button>
                            @for (answer of question.answers; track answer) {
                              <div class="answer">
                                <mat-form-field class="answer-title">
                                  <input matInput required placeholder="Title" [(ngModel)]="answer.text">
                                </mat-form-field>
                                <mat-checkbox [(ngModel)]="answer.isCorrect">{{ 'is_correct' | translate }}</mat-checkbox>
                                <mat-icon (click)="removeAnswer(question.id, answer.id)">minimize</mat-icon>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                </div>
                @if (questions.length > 0) {
                  <button mat-raised-button (click)="addQuestion()">{{ 'add_another_question' | translate }}</button>
                }
                </mat-card-content>
              </mat-card>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="expandAllTabs" (expandedChange)="mediaTabOpen = $event"
              [ngStyle]="{'padding-bottom': mediaTabOpen ? '30px' : '0px'}">
              <mat-expansion-panel-header [ngClass]="{'openHeader': mediaTabOpen}">
                <mat-panel-title>{{ 'media' | translate }}</mat-panel-title>
                <mat-panel-description>
                  {{ 'document_upload' | translate }}
                  <mat-icon>insert_drive_file</mat-icon>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-card appearance="outlined" class="margin">
                <mat-card-header>
                  <mat-card-title>
                    <div class="subtitle">{{ 'picture_upload' | translate }}</div>
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <document-uploader [uploadedFiles]="uploadedPictures" (loadFiles)="uploadPictures($event)"
                  [picturePreview]="true" [cropBeforeLoad]="true"></document-uploader>
                </mat-card-content>
              </mat-card>

              <br>

                <mat-card appearance="outlined" class="margin">
                  <mat-card-header>
                    <mat-card-title>
                      <div class="subtitle">{{ 'video_upload' | translate }}</div>
                    </mat-card-title>
                  </mat-card-header>
                  <mat-card-content>
                    <file-uploader [uploadedFiles]="uploadedVideos" (loadedFiles)="uploadVideo($event)"></file-uploader>
                  </mat-card-content>
                </mat-card>

                <br>

                  <mat-card appearance="outlined" class="margin">
                    <mat-card-header>
                      <mat-card-title>
                        <div class="subtitle">{{ 'document_upload' | translate }}</div>
                      </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      <document-uploader [uploadedFiles]="uploadedDocuments"
                      (loadFiles)="uploadDocuments($event)"></document-uploader>
                    </mat-card-content>
                  </mat-card>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="expandAllTabs" (expandedChange)="categoryTabOpen = $event"
                  [ngStyle]="{'padding-bottom': categoryTabOpen ? '30px' : '0px'}">
                  <mat-expansion-panel-header [ngClass]="{'openHeader': categoryTabOpen}">
                    <mat-panel-title>{{ 'categorise_and_assign' | translate }}</mat-panel-title>
                    <mat-panel-description>
                      <span></span>
                      <mat-icon [ngClass]="{'red-color': (!chosenBoards || (chosenBoards && !chosenBoards.length))}">info
                      </mat-icon>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div>
                    <mat-form-field class="learn-category">
                      <mat-select placeholder="{{'main.learningCategory' | translate}}" multiple
                        (selectionChange)="changeCategory($event)" [value]="chosenCategories">
                        @for (item of learnCategories; track item.id) {
                          <mat-option [value]="item.id">
                            {{ item.name }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="boards">
                      <mat-select placeholder="{{'choose_board' | translate}}" multiple required
                        (selectionChange)="changeBoards($event)" [value]="chosenBoards">
                        @for (space of spaces; track space) {
                          <mat-optgroup [label]="space.name + ' (' + space.platform.title + ')'">
                            @for (board of space.spaceBoard; track board) {
                              <mat-option [value]="board.id">
                                {{ board.name }}
                              </mat-option>
                            }
                          </mat-optgroup>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </mat-expansion-panel>

                <mat-expansion-panel [expanded]="expandAllTabs" (expandedChange)="datesTabOpen = $event">
                  <mat-expansion-panel-header [ngClass]="{'openHeader': datesTabOpen}">
                    <mat-panel-title>{{ 'event.dates' | translate }}</mat-panel-title>
                    <mat-panel-description>
                      {{ 'event.select_dates' | translate }}
                      <mat-icon>calendar_today</mat-icon>
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <mat-form-field class="width-25">
                    <mat-label>{{ 'publishStart' | translate }}</mat-label>
                    <input matInput disabled [matDatepicker]="picker2"
                      [(ngModel)]="publishStart" (ngModelChange)="changeStartPublish($event)">
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-datepicker #picker2 disabled="false"></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="width-25">
                      <mat-label>{{ 'publishTimeStart' | translate }}</mat-label>
                      <input matInput type="time" [(ngModel)]="publishStartTime"
                        (ngModelChange)="closePicker('publishStart', $event)">
                      </mat-form-field>
                      <mat-form-field class="width-25">
                        <mat-label>{{ 'publishEnd' | translate }}</mat-label>
                        <input matInput disabled [matDatepicker]="picker1"
                          [(ngModel)]="publishEnd" (ngModelChange)="changeEndPublish($event)" [min]="minEndDate">
                          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                          <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field class="width-25">
                          <mat-label>{{ 'publishTimeEnd' | translate }}</mat-label>
                          <input matInput type="time" [(ngModel)]="publishEndTime"
                            (ngModelChange)="closePicker('publishEnd', $event)">
                          </mat-form-field>
                        </mat-expansion-panel>
                      </div>
                    </div>
                    <!-- / CONTENT -->

                  </div>
                  <!-- / CONTENT CARD -->

                </div>
                <!-- / CENTER -->
              </div>

